import React from 'react';
import { useFormState } from './useFormState';
import { useFormContext } from 'react-hook-form';
import { Button, Fade, Paper, Stack, Typography } from '@mui/material';
import { NavigateBefore, NavigateNext } from '@mui/icons-material';
import { CustomButton } from '../../../../layout/styledcomponents/CustomButton';

const CreateActions = ({
    isLoading,
    disabled,
    handleSave,
}: {
    isLoading: boolean;
    disabled: boolean;
    handleSave: () => void;
}) => {
    const { stepIndex, handlePrevious } = useFormState();
    return (
        <>
            {stepIndex > 0 && (
                <Button
                    variant='outlined'
                    startIcon={<NavigateBefore />}
                    onClick={handlePrevious}
                >
                    Back
                </Button>
            )}
            <Button variant='outlined' onClick={handleSave} disabled={disabled}>
                Save and Exit
            </Button>
            <CustomButton
                type='submit'
                variant='contained'
                endIcon={<NavigateNext />}
                loading={isLoading}
                disabled={disabled}
            >
                Next
            </CustomButton>
        </>
    );
};

const EditActions = ({
    isLoading,
    disabled,
}: {
    isLoading: boolean;
    disabled: boolean;
}) => {
    const { reset } = useFormContext();

    const handleCancel = () => {
        reset();
    };

    return (
        <>
            <Button onClick={handleCancel}>Cancel</Button>
            <CustomButton
                type='submit'
                variant='contained'
                loading={isLoading}
                disabled={disabled}
            >
                Save Changes
            </CustomButton>
        </>
    );
};

const NavigationActions = ({
    isLoading,
    handleSave,
}: {
    isLoading: boolean;
    handleSave: () => void;
}) => {
    const { workflow, isSaveDisabled } = useFormState();
    const {
        formState: { isDirty },
    } = useFormContext();

    return (
        <Fade
            in={workflow === 'create' || isDirty}
            appear={workflow === 'edit'}
        >
            <Paper
                sx={(theme) => ({
                    display: 'flex',
                    alignItems: 'center',
                    position: 'sticky',
                    bottom: theme.spacing(2),
                    mt: 4,
                    borderRadius: 4,
                    p: 2,
                    zIndex: 1000,
                })}
            >
                <Fade in={isDirty}>
                    <Typography variant='body2' color='text.secondary'>
                        Changes not saved
                    </Typography>
                </Fade>
                <Stack direction='row' sx={{ gap: 1, ml: 'auto' }}>
                    {workflow === 'create' ? (
                        <CreateActions
                            isLoading={isLoading}
                            disabled={isSaveDisabled}
                            handleSave={handleSave}
                        />
                    ) : (
                        <EditActions
                            isLoading={isLoading}
                            disabled={isSaveDisabled}
                        />
                    )}
                </Stack>
            </Paper>
        </Fade>
    );
};
export default NavigationActions;
